
<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path
    fill="#99005C"
    fill-rule="evenodd"
    d="M19.586 13l-3.293 3.293c-.39.39-.39 1.024 0 1.414.39.39 1.024.39 1.414 0l5-5c.39-.39.39-1.024 0-1.414l-5-5c-.39-.39-1.024-.39-1.414 0-.39.39-.39 1.024 0 1.414L19.586 11H2c-.552 0-1 .448-1 1s.448 1 1 1h17.586z"
    clip-rule="evenodd"
  />
</svg>
